import { render, staticRenderFns } from "./recommendedReport.vue?vue&type=template&id=207d1f47&scoped=true"
import script from "./recommendedReport.vue?vue&type=script&lang=js"
export * from "./recommendedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d1f47",
  null
  
)

export default component.exports